import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { ALL, ASSIGNED, READ, UNREAD } from '@routes/sidebar/notifications/___shared___/constants.ts';
import type { NotificationDetails } from '@routes/sidebar/notifications/api/notifications.api.ts';
import { Assigned, TabItem } from '@routes/sidebar/notifications/styled.tsx';
import CardsList from '@routes/sidebar/notifications/ui/card-list';
import { PillTag } from '@routes/sidebar/notifications/ui/tag-pill';
import { translateItem } from '@utils/translations.ts';

export const SHARED_NOTIFICATIONS_TABS_TAB_READ = msg`Read`;
export const SHARED_NOTIFICATIONS_TABS_TAB_UNREAD = msg`Unread`;

// needs to be a hook to use useLingui() safely
export const useTabs = (notifications: NotificationDetails[], assignedNew: number, activeKey: string) => {
    const { t } = useLingui();
    const TABS = [
        { key: ALL, label: t`All` },
        {
            key: ASSIGNED,
            label: (
                <Assigned>
                    {t`Assigned`} {assignedNew > 0 && <PillTag source={'New'} type={''} />}
                </Assigned>
            ),
        },
        { key: UNREAD, label: translateItem(SHARED_NOTIFICATIONS_TABS_TAB_UNREAD) },
        { key: READ, label: translateItem(SHARED_NOTIFICATIONS_TABS_TAB_READ), showMarkAllAsRead: false },
    ];

    return TABS.map(({ key, label, showMarkAllAsRead }) => ({
        key,
        label: <TabItem $isSelected={key === activeKey}>{label}</TabItem>,
        children: <CardsList notifications={notifications} showMarkAllAsRead={showMarkAllAsRead} />,
    }));
};
